module.exports = __webpack_public_path__ + "img/59.50c7f3e0.jpg";